import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../api/client";
import { useEvent } from "../context/EventProvider";
import { useSession } from "./useSession";
import { useSessionKey } from "./useSessionKey";

/**
 * ═══ AI-JE LE DROIT DE CONFIGURER CE SITE ? ═══
 *
 * Le bouton « Configurer le site » se montrait à tout le monde, connecté ou non : un
 * participant pouvait ouvrir le panneau et, comme il écrit pour de vrai, modifier
 * l'événement (la route d'écriture ne refuse qu'en mode `enforce`, voir
 * `api/src/hooks/useRightsGuard.js`). La question se pose donc au serveur, avec LA
 * MÊME règle que la route d'écriture : `GET …/rights/mine` répond `configure` si la
 * session porte un rôle `CUSTOMIZATIONS_FO*` sur le domaine ou sur cet événement.
 *
 * Sans session, la réponse est « non » sans demander. Tant qu'on ne sait pas : « non »
 * aussi, le bouton apparaît quand la réponse arrive, jamais l'inverse.
 */
export function useCanConfigure(): boolean {
  const event = useEvent();
  const signedIn = useSession();
  // Le droit est celui de CE compte : un autre onglet qui change de session change la clef.
  const sessionKey = useSessionKey();
  const q = useQuery({
    queryKey: ["rights-mine", event?.domainId, event?.eventId, sessionKey],
    queryFn: ({ signal }) =>
      apiFetch<{ rights?: { configure?: boolean } } | null>(
        `/domains/${event!.domainId}/events/${event!.eventId}/rights/mine`,
        { api: "apix", signal },
      ),
    enabled: !!event && signedIn,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return signedIn && q.data?.rights?.configure === true;
}
